// @flow
import React, { Component } from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import { EmptyResults } from "../../common";
import styles from "./Notifications.scss";
import Box from "../box/Box";

const Notifications = (props: Object) => {
  const { data, type, readNotification } = props;
  let typeText = "";
  switch (type) {
    case "1":
      typeText = I18n.getText("notification.read");
      break;
    case "0":
      typeText = I18n.getText("notification.unread");
      break;
    default:
      typeText = "";
  }

  const itemList =
    data && !_.isEmpty(data) ? (
      data.map((item, index) => {
        return (
          <div className={`${styles.item} ${item.is_read ? styles.read : ""}`}>
            <Box data={item} key={index} readNotification={readNotification} />
          </div>
        );
      })
    ) : (
      <EmptyResults
        style={{ minHeight: "unset" }}
        heading={I18n.getText("notification.blank-type", { type: typeText })}
      />
    );

  return <div className={styles.listCtr}>{itemList}</div>;
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/notifications/notifications/Notifications.js